module.exports = __webpack_public_path__ + "static/6h-hardworking-714e564401e7d62e66d80994e6314c9a.png";